// extracted by mini-css-extract-plugin
export var active = "_8o-7";
export var container = "_8o-0";
export var evenWidth = "_8o-4";
export var large = "_8o-5";
export var outlet = "_8o-8";
export var slide = "_8o-2";
export var small = "_8o-6";
export var tab = "_8o-3";
export var tabs = "_8o-1";